import { EditOutlined, PlusOutlined, ToolOutlined } from '@ant-design/icons'
import { Button, Typography } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { AppHeader, ColumnLayout, WebsiteTab } from '@/components'
import { useGetWebsitesQuery } from '@/generated/graphql'
import { WebsitesContainer } from '@/modules/websites/websites.container'

import { useIsSystemAdmin } from '../admin/admin.hooks'
import { WebsiteSetCommonContext } from '../app'
import { WebsiteCategoryCreateEditModal } from '../websites/website-modal/website-category-create-edit-modal.component'
import s from './tools.module.less'

export const ToolsContainer = () => {
  const { t } = useTranslation()

  const isSystemAdmin = useIsSystemAdmin()
  const { visible, toggle } = React.useContext(WebsiteSetCommonContext)

  const appHeader = (
    <AppHeader
      title={t('tools.title')}
      avatar={<ToolOutlined style={{ fontSize: 28 }} />}
      actions={
        <div className={s.appHeaderActions}>
          {isSystemAdmin && (
            <WebsiteCategoryCreateEditModal>
              <Button type='primary' ghost icon={<PlusOutlined />}>
                {t('website.addCatalog')}
              </Button>
            </WebsiteCategoryCreateEditModal>
          )}
          <Button
            type='primary'
            ghost={!visible}
            icon={<EditOutlined />}
            onClick={() => toggle()}
            className={s.setCommon}
          >
            {visible ? t('tools.finishCommon') : t('tools.setCommon')}
          </Button>
        </div>
      }
    />
  )

  const { data } = useGetWebsitesQuery({
    variables: {
      pagination: {
        last: 1000,
      },
      isCommon: true,
    },
  })

  const websites: { link: string; title: string; avatarSrc?: string }[] = (
    data?.website.entities.edges.slice().map(({ node }) => node) || []
  ).map((website) => ({
    title: website.title,
    link: website.url,
    avatarSrc: website.faviconUrl || undefined,
  }))

  const header = (
    <div className={s.header}>
      <Typography.Title level={5} className={s.title}>
        {t('tools.commonUse')}
      </Typography.Title>
      <div className={s.content}>
        {websites.map((link) => (
          <WebsiteTab key={link.link} avatarSrc={link.avatarSrc} title={link.title} link={link.link} />
        ))}
      </div>
    </div>
  )

  const middle = (
    <div className={s.container}>
      {header}
      <WebsitesContainer />
    </div>
  )

  return <ColumnLayout header={appHeader} middle={middle} />
}
